import isEmpty from '@common/helpers/isEmpty';

/**
 * Pick keys from object
 */
const pick = keys => obj => {
  if (isEmpty(obj)) {
    return obj;
  }
  if (isEmpty(keys)) {
    return {};
  }
  const picked = {};
  keys.forEach(key => {
    picked[key] = obj[key];
  });
  return picked;
};

export default pick;
